// extracted by mini-css-extract-plugin
export default {"resource":"N-","title":"O-","items":"P-","resource_item":"Q-","text":"R-","button":"S-"};
    if(module.hot) {
      // 1715276859863
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  